import React from 'react';

const Loading = () => (
  <p className="quote">
    <q className="quote__text">Is that all there is?</q>
    <span className="quote__author">Peggy Lee</span>
  </p>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js